import { create } from 'zustand';
import type { LimitErrorCode, PaywallPayload } from '@/shared/lib/api';

/**
 * Holds the currently visible server-driven limit paywall. The dialog is
 * mounted once at the root; feature code just calls `showPaywall(payload, code)`
 * and the shared `<LimitPaywallDialog />` picks it up.
 *
 * `code` is kept alongside the payload so consumers (e.g. analytics) can tell
 * which limit triggered it without re-parsing the error.
 */
interface LimitPaywallState {
  code: LimitErrorCode | null;
  payload: PaywallPayload | null;
  showPaywall: (payload: PaywallPayload, code: LimitErrorCode) => void;
  hidePaywall: () => void;
}

export const useLimitPaywallStore = create<LimitPaywallState>((set) => ({
  code: null,
  payload: null,
  showPaywall: (payload, code) => set({ payload, code }),
  hidePaywall: () => set({ payload: null, code: null }),
}));
